type Props = {
  page: number;
  totalPage: number;
  onChange: (page: number) => void;
};

function visiblePageRange(current: number, total: number): number[] {
  if (total <= 12) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages = new Set<number>();
  pages.add(1);
  pages.add(total);
  for (let p = current - 2; p <= current + 2; p++) {
    if (p >= 1 && p <= total) pages.add(p);
  }
  return Array.from(pages).sort((a, b) => a - b);
}

export default function PaginationBar({ page, totalPage, onChange }: Props) {
  if (totalPage <= 1) return null;

  const pages = visiblePageRange(page, totalPage);

  return (
    <div className="page-wrapper">
    <nav className="people-client-pagination" aria-label="Pagination">
      <button
        type="button"
        className="people-client-pagination__btn"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      >
        Previous
      </button>
      {pages.map((p, i) => {
        const prev = pages[i - 1];
        const showEllipsis = i > 0 && prev !== undefined && p - prev > 1;
        return (
          <span key={p} className="people-client-pagination__group">
            {showEllipsis && <span className="people-client-pagination__ellipsis" aria-hidden>...</span>}
            <button
              type="button"
              className={
                p === page
                  ? 'people-client-pagination__btn people-client-pagination__btn--current'
                  : 'people-client-pagination__btn'
              }
              onClick={() => onChange(p)}
              aria-current={p === page ? 'page' : undefined}
            >
              {p}
            </button>
          </span>
        );
      })}
      <button
        type="button"
        className="people-client-pagination__btn"
        disabled={page >= totalPage}
        onClick={() => onChange(page + 1)}
      >
        Next
      </button>
    </nav>
    </div>
  );
}
